import { ReactNode } from 'react';

import { Flex, Text } from '@chakra-ui/react';
import { CloseIcon } from '@udacity/chakra-uds-icons';

type ChipTheme = 'light' | 'dark' | 'sky';

export function Chip({
  text,
  icon,
  theme = 'light',
  closable,
  onCloseClick,
}: {
  text: string;
  icon?: ReactNode;
  theme?: ChipTheme;
  closable?: boolean;
  onCloseClick?: () => void;
}) {
  return (
    <Flex
      alignItems='center'
      as={closable ? 'button' : 'div'}
      bg={bgColorMap.get(theme)}
      border='solid 1px'
      borderColor={borderColorMap.get(theme)}
      borderRadius='2px'
      gap='4px'
      p='6px'
      width='fit-content'
      {...(closable && onCloseClick && { onClick: onCloseClick })}
    >
      {icon && icon}
      <Text
        color={theme === 'dark' ? 'white' : 'grey.500'}
        fontWeight='400'
        size='small-label'
        textTransform='capitalize'
        whiteSpace='nowrap'
      >
        {text}
      </Text>
      {closable && <CloseIcon />}
    </Flex>
  );
}

const bgColorMap = new Map<ChipTheme, string>();
bgColorMap.set('light', 'grey.50');
bgColorMap.set('dark', 'blue.700');
bgColorMap.set('sky', 'accent.sky.100');

const borderColorMap = new Map();
borderColorMap.set('light', 'grey.100');
borderColorMap.set('dark', '#6597FF');
borderColorMap.set('sky', 'blue.500');
